// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* From HKUST page reuses the shared .filter / .container styling. */
.container {
  width: 100%;
  padding: 0.5em;
}
/*# sourceMappingURL=FromHkustPage.css.map */`, "",{"version":3,"sources":["webpack://./src/containers/FromHkustPage/FromHkustPage.less","webpack://./FromHkustPage.less"],"names":[],"mappings":"AAAA,oEAAoE;ACCpE;EACI,WAAA;EACA,cAAA;ADCJ;AACA,4CAA4C","sourcesContent":["/* From HKUST page reuses the shared .filter / .container styling. */\n.container {\n  width: 100%;\n  padding: 0.5em;\n}\n/*# sourceMappingURL=FromHkustPage.css.map */","/* From HKUST page reuses the shared .filter / .container styling. */\n.container {\n    width: 100%;\n    padding: .5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
